import React, { useEffect, useState } from "react";
import "./index.scss";
import Auth from "./Components/Auth/Auth";
import { useGTM } from "./Components/GTM";
// import useGTM from "./Components/GTM";
const App = () => {
  // const [gtmId, setGtmId] = useState(localStorage.getItem("gtmId") || "GTM-XXXXXXX");
  // let gtmId = localStorage.getItem("gtmId") || process.env.REACT_APP_GTM_ID || "GTM-XXXXXXX";

  const { setGtm } = useGTM();

  useEffect(() => {
    if (localStorage.getItem("gtmId"))
      setGtm(localStorage.getItem("gtmId"));
  }, [localStorage.getItem("gtmId")]);

  return (
    <>
      <Auth />
    </>
  );
};

export default App;
